import React from "react";
import "./app-shell-desktop.css";
import { AppShellDesktopActions } from "./AppShellDesktopActions";
export type AppShellDesktopConfiguration = {
  notifyInteractionBlocked?: (blocked: boolean) => void;
  menu: { title: string; icon: string; label: string; open: (position?: { x: number; y: number }) => void; subscribeClosed: (callback: () => void) => () => void };
  caption?: { isMaximized: () => boolean; subscribeMaximized: (callback: (maximized: boolean) => void) => () => void; minimize: () => void; toggleMaximize: () => void; close: () => void; labels: { minimize: string; maximize: string; restore: string; close: string }; hostAttributes?: Record<string, string> };
};
export function AppShellDesktopWindowMenu({ menu }: { menu: AppShellDesktopConfiguration["menu"] }) {

  const buttonRef = React.useRef<HTMLButtonElement>(null);
  const [open, setOpen] = React.useState(false);
  const iconSrc = menu.icon;

  const subscribeClosed = menu.subscribeClosed;
  React.useEffect(() => subscribeClosed(() => setOpen(false)), [subscribeClosed]);

  return (
    <button
      ref={buttonRef}
      type="button"
      className={`mu-desktop-app-menu${open ? " is-open" : ""}`}
      aria-haspopup="menu"
      aria-expanded={open}
      aria-label={menu.label}
      onClick={() => {
        const box = buttonRef.current?.getBoundingClientRect();
        setOpen(true);
        menu.open(
          box ? { x: Math.round(box.left), y: Math.round(box.bottom) } : undefined,
        );
        return buttonRef.current?.blur();
      }}
    >
      {iconSrc ? <img className="mu-desktop-app-menu-icon" src={iconSrc} alt="" width={28} height={28} /> : null}
      <span className="mu-desktop-app-menu-title">{menu.title}</span>
      <svg className="mu-desktop-app-menu-chevron" viewBox="0 0 12 12" aria-hidden="true">
        <path
          d="M2.5 4.5 L6 8 L9.5 4.5"
          fill="none"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </button>
  );
}
function CaptionIcon({ kind }: { kind: "minimize" | "maximize" | "restore" | "close" }) {
  if (kind === "minimize") {
    return (
      <svg viewBox="0 0 10 10" aria-hidden="true">
        <path d="M1 5h8" fill="none" stroke="currentColor" strokeWidth="1" />
      </svg>
    );
  }
  if (kind === "restore") {
    return (
      <svg viewBox="0 0 10 10" aria-hidden="true">
        <path d="M3 2.5h4.5v4.5H3zM2 4h1V3.5H7.5V8H3.5V7H2z" fill="none" stroke="currentColor" strokeWidth="1" />
      </svg>
    );
  }
  if (kind === "maximize") {
    return (
      <svg viewBox="0 0 10 10" aria-hidden="true">
        <rect x="1.5" y="1.5" width="7" height="7" fill="none" stroke="currentColor" strokeWidth="1" />
      </svg>
    );
  }
  return (
    <svg viewBox="0 0 10 10" aria-hidden="true">
      <path d="M2 2l6 6M8 2L2 8" fill="none" stroke="currentColor" strokeWidth="1" />
    </svg>
  );
}
export function AppShellDesktopCaptionButtons({ caption }: { caption: NonNullable<AppShellDesktopConfiguration["caption"]> }) {

  const [maximized, setMaximized] = React.useState(caption.isMaximized);

  const subscribeMaximized = caption.subscribeMaximized;
  React.useEffect(() => subscribeMaximized(setMaximized), [subscribeMaximized]);



  return (
    <div className="mu-desktop-caption-buttons mu-desktop-no-drag" {...caption.hostAttributes}>
      <button
        type="button"
        className="mu-desktop-caption-button"
        aria-label={caption.labels.minimize}
        title={caption.labels.minimize}
        onClick={() => caption.minimize()}
      >
        <CaptionIcon kind="minimize" />
      </button>
      <button
        type="button"
        className="mu-desktop-caption-button"
        aria-label={maximized ? caption.labels.restore : caption.labels.maximize}
        title={maximized ? caption.labels.restore : caption.labels.maximize}
        onClick={() => caption.toggleMaximize()}
      >
        <CaptionIcon kind={maximized ? "restore" : "maximize"} />
      </button>
      <button
        type="button"
        className="mu-desktop-caption-button mu-desktop-caption-close"
        aria-label={caption.labels.close}
        title={caption.labels.close}
        onClick={() => caption.close()}
      >
        <CaptionIcon kind="close" />
      </button>
    </div>
  );
}
export function AppShellDesktopTitlebar({ configuration }: { configuration: AppShellDesktopConfiguration }) {
  return <div className="mu-desktop-titlebar"><AppShellDesktopActions notifyBlocked={configuration.notifyInteractionBlocked}><AppShellDesktopWindowMenu menu={configuration.menu} /></AppShellDesktopActions><span className="mu-desktop-titlebar-spacer" />{configuration.caption ? <AppShellDesktopCaptionButtons caption={configuration.caption} /> : null}</div>;
}
